module.exports = __webpack_public_path__ + "img/audio@2x.4f1c24b.svg";